module.exports = __webpack_public_path__ + "static/supplier-2-a3c79abb943732a31ec1fdd7fb92b916.png";